export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13364.b0bd138e.jpg";